import { Box, Container, Image, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SplitHeading } from '../components/SplitHeading';
import { ScrollDownLink } from '../components/ScrollDownLink';

const BG = '/images/landing/licensing-bg.jpg';
// Single composed artwork (phone + "Café Morning Flow" card + connector +
// "Licensed" badge) exported from the redesign (Figma 30:498) — replaces the
// old standalone card + separate connector + live badge.
const ART = '/images/landing/licensing-artwork.png';

function LicensingText() {
  const { t } = useTranslation();
  return (
    <Box maxW="637px">
      <Text
        fontFamily="heading"
        fontSize="display.lg"
        fontWeight={600}
        color="#E5D8D7"
        lineHeight={1}
        textAlign={{ base: 'left', xl: 'right' }}
        mb={{ base: '12px', xl: '32px' }}
      >
        03
      </Text>
      <Stack spacing="16px" align="flex-start">
        <SplitHeading
          as="h2"
          text={t('landing.licensing.title')}
          fontFamily="heading"
          fontWeight={700}
          fontSize="display.lg"
          lineHeight={1.18}
          letterSpacing="-0.01em"
          color="onboarding.deepPlum"
        />
        <Text fontSize="md" lineHeight="25px" color="onboarding.roseMid">
          {t('landing.licensing.body')}
        </Text>
        <Box alignSelf="flex-end" pt="12px">
          <ScrollDownLink targetId="why" label={t('landing.showcase.scrollDown')} />
        </Box>
      </Stack>
    </Box>
  );
}

export function Licensing() {
  const { t } = useTranslation();
  return (
    <Box
      as="section"
      id="licensing"
      position="relative"
      overflow="hidden"
      bgGradient="linear(135deg, #fffaf9 5%, #fbe5d8 82%)"
    >
      {/* Warm-gradient section; the wave decoration is overlaid with multiply. */}
      <Image
        src={BG}
        alt=""
        position="absolute"
        inset={0}
        w="100%"
        h="100%"
        objectFit="cover"
        mixBlendMode="multiply"
        opacity={0.85}
        pointerEvents="none"
      />

      {/* Desktop: 1440 stage matching Figma coordinates (artwork left, text right). */}
      <Box display={{ base: 'none', xl: 'block' }} position="relative" w="1440px" minH="708px" mx="auto">
        <Image
          src={ART}
          alt={t('landing.licensing.labelLicensed')}
          position="absolute"
          left="133px"
          top="67px"
          w="499px"
          draggable={false}
        />
        <Box ml="677px" pt="120px" pb="40px" w="637px">
          <LicensingText />
        </Box>
      </Box>

      {/* Tablet / mobile: stacked */}
      <Container display={{ base: 'block', xl: 'none' }} maxW="720px" py={{ base: 16, md: 24 }}>
        <Stack spacing={8} align="center">
          <Image
            src={ART}
            alt={t('landing.licensing.labelLicensed')}
            w={{ base: '300px', md: '380px' }}
            draggable={false}
          />
          <LicensingText />
        </Stack>
      </Container>
    </Box>
  );
}
